import { render } from "./WithdrawInfoModal.vue?vue&type=template&id=cea5c4a6&scoped=true"
import script from "./WithdrawInfoModal.vue?vue&type=script&lang=js"
export * from "./WithdrawInfoModal.vue?vue&type=script&lang=js"

import "./WithdrawInfoModal.vue?vue&type=style&index=0&id=cea5c4a6&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea5c4a6"]])

export default __exports__